import { useSelector } from "react-redux";
import { AppState } from "../redux/AppTypes";

export function useEmail() {
  const email = useSelector((state: AppState) => state.authorization.email);
  return email;
}
